import { useMemo } from 'react';

interface UsePriceCalculationArgs {
  isEdit: string;
  product: any;
  covers: any[] | undefined;
  inputCover: any;
  inputPackaging: boolean | undefined;
  imagePrice: number;
  settings: any;
  showPackagingOption: boolean;
}

export const usePriceCalculation = ({
  isEdit,
  product,
  covers,
  inputCover,
  inputPackaging,
  imagePrice,
  settings,
  showPackagingOption,
}: UsePriceCalculationArgs): number => {
  return useMemo(() => {
    const basePrice =
      isEdit === '1'
        ? Number(product?.price || product?.fron_price?.amount || 0)
        : Number(product?.front_price?.amount || product?.price?.amount || 0);

    let coverPrice = 0;
    if (covers && inputCover) {
      const cover = covers.find((c: any) => String(c.id) === String(inputCover));
      if (cover?.price?.amount !== undefined) {
        coverPrice =
          typeof cover.price.amount === 'number'
            ? cover.price.amount
            : parseFloat(cover.price.amount) || 0;
      } else if (cover?.price_usd !== undefined) {
        coverPrice = parseFloat(cover.price_usd) || 0;
      } else if (cover?.price_ils !== undefined) {
        coverPrice = parseFloat(cover.price_ils) || 0;
      }
    }

    let packagingPrice = 0;
    if (showPackagingOption) {
      if (isEdit === '1' && product?.packaging?.name === 'Packaging') {
        packagingPrice = parseFloat(product.packaging.price || '0');
      } else if (inputPackaging === true) {
        packagingPrice = parseFloat(settings?.packaging_price || '0');
      }
    }

    const total = basePrice + coverPrice + packagingPrice + imagePrice;
    return isNaN(total) ? basePrice : total;
  }, [isEdit, product, covers, inputCover, inputPackaging, imagePrice, settings, showPackagingOption]);
};
